/// <amd-module name="Artifacts/Cargo/ICargoProtocolMetadata" />
export interface ICargoProtocolMetadata {
  categories?: string[];
  documentationUrl?: string;
  features?: { [feature: string]: string[] };
  homepageUrl?: string;
  licenseExpression?: string;
  repositoryUrl?: string;
}
